import "../../../DrugAssignmentBatchRelease/DrugAssignment.css";
import { Grid2 } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import logo from "../../../../assets/logos/admin_logo.svg";

const ConfirmSite = ({ setShowConfirm, data }) => {
  const navigate = useNavigate();

  const fields = [
    { label: "Site Name", key: "name" },
    { label: "Site Number", key: "siteNumber" },
    { label: "Site Investigator Name", key: "investigator" },
    { label: "Primary Contact", key: "primaryContact" },
    { label: "Shipping Address", key: "displayAddress" },
    { label: "City", key: "city" },
    { label: "State", key: "state" },
    { label: "Zip Code", key: "zip" },
    { label: "Site Country", key: "countryName" },
    { label: "Phone Number", key: "phoneNumber" },
    { label: "Fax Number", key: "faxNumber" },
    { label: "Time Zone", key: "timeZone" },
    { label: "Site Active", key: "isActive" },
    { label: "Drug Ordering Enabled", key: "isDrugOrderingEnabled" },
    { label: "Screening Open", key: "isScreeningOpen" },
    { label: "Randomization Open", key: "isRandomizationOpen" },
    { label: "Supply Depot", key: "depotName" },
    { label: "Return Depot", key: "returnDepotName" },
  ];

  const email = localStorage.getItem("email");

  return (
    <div className="content-body">
      <p className="bread-crumbs-link-container" style={{ fontWeight: "600" }}>
        <Link className="bread-crumbs-link" to="/">
          Home
        </Link>{" "}
        |{" "}
        <Link
          className="bread-crumbs-link"
          to="/site-management"
          onClick={() => setShowConfirm(false)}
        >
          Site Management
        </Link>
        |{" "}
        <Link className="bread-crumbs-link">Site Activation Confirmation</Link>-{" "}
        <b style={{ color: "gray" }}>{localStorage?.getItem("studyName")}</b>
      </p>
      <Grid2
        container
        alignItems="center"
        justifyContent="space-between"
        sx={{ width: "100%", margin: "0 auto" }}
      >
        <Grid2 item md={6}>
          <p className="page-heading">
            Genesis StudyPortal Site Activation Confirmation
          </p>
        </Grid2>
      </Grid2>
      <div className="heading-container">
        <h4>Site Activation Alert Genesis StudyPortal</h4>
      </div>
      <div className="inner-heading-container">
        <img className="admin-logo logo-image" src={logo} alt="Genesis Logo" />
        <div className="data-block">
          <div className="data-inner-block">
            <span
              className="data-inner-block-text"
              style={{
                display: "block",
                width: "210px",
                textAlign: "right",
              }}
            >
              User Name :{" "}
            </span>
            <span
              style={{
                color: "white",
                textAlign: "left",
              }}
            >
              {" "}
              {email}
            </span>
          </div>

          <div className="data-inner-block">
            <span
              className="data-inner-block-text"
              style={{
                display: "block",
                width: "210px",
                textAlign: "right",
              }}
            >
              System Transaction Date :
            </span>
            <span
              style={{
                color: "white",
                textAlign: "left",
              }}
            >
              {" "}
              {new Date().toLocaleDateString()}
            </span>
          </div>
        </div>
      </div>
      <div className="data-content-container">
        {fields.map(({ label, key }) => (
          <div className="data-content" key={key}>
            <span
              className="data-content-label"
              style={{
                width: "16.5vw",
              }}
            >
              {label} :
            </span>
            <span
              className="data-content-value"
              style={{
                width: "277px",
                wordBreak: "break-word",
              }}
            >
              {data?.[key] === true
                ? "True"
                : data?.[key] === false
                ? "False"
                : data?.[key]}
            </span>
          </div>
        ))}
      </div>

      <div className="note-container">
        <span
          style={{
            fontWeight: "600",
            color: "#585858",
          }}
        >
          Note :
        </span>
        <span>The site noted above has been activated.</span>
      </div>
      <div
        style={{
          height: "20px",
        }}
      ></div>
      <div className="footer-container">
        <span>
          Genesis 2025-Please contact Genesis Support for assistance at
          Genesis.com/support
        </span>
      </div>
      <div
        style={{
          textAlign: "left",
          margin: "10px",
          fontSize: "10px",
        }}
      >
        You will receive an email confirmation of this transaction.
      </div>
      <Grid2
        alignItems={"center"}
        justifyContent="center"
        container
        gap={3}
        sx={{ marginTop: "2%" }}
      >
        <Grid2 item md={6}>
          <button
            className="create-btn"
            onClick={() => {
              navigate("/");
            }}
          >
            Home
          </button>
        </Grid2>
      </Grid2>
    </div>
  );
};

export default ConfirmSite;
